import React,{ useState ,useRef, useEffect} from 'react';
import { Button,Form,Col,Row,Alert} from 'react-bootstrap';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Logo from '../assets/icons/logo2.jpeg';
import UserNav from './UserNav';
import { enterFullScreen } from '../utils/fullScreen.js';
import { currentYear } from '../utils/currentYear.js';


const InstructionsPage = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const candidateID = searchParams.get('id');   
    const examType = searchParams.get('exam-type');
    const [success, setSuccess] = useState('');
    const speechSynthRef = useRef(null); // Ref to hold the SpeechSynthesisUtterance instance-------R


    // // rohith start
    // const enterFullScreen = async () => {
    //     try {
    //       // Request media permissions (if needed)
    //       await navigator.mediaDevices.getUserMedia({ audio: true, video: true });
      
    //       // Request full-screen mode
    //       if (document.documentElement.requestFullscreen) {
    //         await document.documentElement.requestFullscreen();
    //       } else if (document.documentElement.mozRequestFullScreen) { // Firefox
    //         await document.documentElement.mozRequestFullScreen();
    //       } else if (document.documentElement.webkitRequestFullscreen) { // Chrome, Safari, and Opera
    //         await document.documentElement.webkitRequestFullscreen();
    //       } else if (document.documentElement.msRequestFullscreen) { // IE/Edge
    //         await document.documentElement.msRequestFullscreen();
    //       }
    //     } catch (error) {
    //       console.error('Error attempting to enable full-screen mode or access media devices:', error);
    //     }
    //   };
    // // rohith end

    // const handleSubmit=() =>{
    //     if(examType === 'THEORY'){
    //         navigate(/users-questions?id=${candidateID});
    //     }else{
    //         navigate(/code-interview?id=${candidateID});
    //     }
       

    // }commenetd to use the below block
    // rohith start
    // Function to speak the instructions
    const speakInstructions = () => {
        const instructions = [
            "Provide detailed and well-structured answers to each question. Stay focused and to the point.",
            "Avoid switching tabs during the interview. Any tab switch will be notified, and repeated violations may lead to termination.",
            "If a question is unclear or too complex, feel free to request a simplified or repeated version for better understanding."
        ];
    
        const utterance = new SpeechSynthesisUtterance(instructions.join(' '));
        utterance.rate = 1; // Adjust the speech rate if needed
        utterance.pitch = 1; // Adjust the pitch if needed
        utterance.volume = 1; // Adjust the volume if needed
    
        // *Select Microsoft Zira Voice*
        const voices = window.speechSynthesis.getVoices();
        let ziraVoice = voices.find(voice => voice.name.includes("Zira"));
    
        if (ziraVoice) {
            utterance.voice = ziraVoice;
            console.log("✅ Using Zira voice:", ziraVoice.name);
        } else {
            console.warn("⚠ Zira voice not found. Using default voice.");
        }
    
        speechSynthRef.current = utterance;
        window.speechSynthesis.speak(utterance);
    };

    const stopSpeech = () => {
        if (window.speechSynthesis) {
            window.speechSynthesis.cancel(); // Stop any ongoing speech
            console.log("🛑 Speech stopped");
        }
    };
    

    // Speak instructions when the component mounts
    useEffect(() => {
        const loadVoices = () => {
            if (window.speechSynthesis.getVoices().length > 0) {
                speakInstructions();
            } else {
                setTimeout(loadVoices, 100); // Retry after a short delay
            }
        };
    
        loadVoices();
    
        return () => {
            stopSpeech(); // ✅ Now properly defined and used
        };
    }, []);
    

    // Handle the "Start Test" button click
    const handleSubmit = async () => {
        stopSpeech(); // ✅ Now properly defined and used
    
        try {
            await enterFullScreen();
    
            setTimeout(() => {
                if (examType === 'THEORY') {
                    navigate(`/users-questions?id=${candidateID}`);
                } else {
                    navigate(`/code-interview?id=${candidateID}`);
                }
            }, 500);
        } catch (error) {
            console.error('Error enabling full-screen mode:', error);
            if (examType === 'THEORY') {
                navigate(`/users-questions?id=${candidateID}`);
            } else {
                navigate(`/code-interview?id=${candidateID}`);
            }
        }
    };
    
    //   rohith end
    const handleSubmit2 = () => {
        stopSpeech(); // Stop the speech before navigating

        if (examType === 'THEORY') {
            navigate(`/UsersDemoQuestions?id=${candidateID}`, { state: { examType: examType } });
        } else {
            navigate(`/UsersDemoQuestions?id=${candidateID}`, { state: { examType: examType } });
        }
    };



    // rohith start
    useEffect(() => {
        const handleFullScreenChange = () => {
          if (!document.fullscreenElement) {
            // User exited full-screen mode
            console.log('Exited full-screen mode');
            // You can add additional logic here if needed
          }
        };
      
        document.addEventListener('fullscreenchange', handleFullScreenChange);
      
        return () => {
          document.removeEventListener('fullscreenchange', handleFullScreenChange);
        };
      }, []);
    // rohith end


    return(
        <div className='instruct-div'>
      
      <UserNav />
        
        <div >
            <div className='inst-condition-div'>
                <h1>EngageTalent.AI Test Guidelines:</h1>
                {examType === 'THEORY' && 
                     <p>
                     <strong>Question Answering: </strong>
                     Click the Mic icon and start answering.
                     </p>
                }
           
                {/* <p>
                <strong>Zoom Call: </strong>
                You must remain on the Zoom call throughout the test.
                </p> */}
                <p>
                <strong>Test Environment: </strong>
                Take the test in a quiet room to avoid disturbances.
                </p>
                <p>
                <strong>Page Refresh: </strong>
                Do not refresh the test page at any time during the test.
                </p>
                <p>
                <strong>Question Navigation: </strong>
                You cannot return to or change answers for previously submitted questions.

                </p>
                <p>
                <strong>Video and Screen Sharing: </strong>
                Keep your video on and share your screen during the test.
                </p>
                <p>
                <strong>Browsing Restrictions: </strong>
                Do not open any websites or browse the internet during the test. Doing so will result in disqualification.
                </p>
                <p>
                <strong>Technical Issues: </strong>
                If you encounter internet problems or other issues, immediately inform the recruiter.

                </p>
                {examType === 'THEORY' && 
                     <p>
                     <strong>Answer Editing: </strong>
                     You cannot edit your answers after recording them. You can only clear and re-record the answer.
                     </p>
                }
           
                <p>
                <strong>Audio Requirements: </strong>
                Do not mute your audio during the exam.
                </p>
                <p>
                <strong>Timely Submission: </strong>
                Complete and submit your exam within the allotted time. Late submissions may not be considered.
                </p>

                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button variant="dark" onClick={handleSubmit} style={{ marginTop: '20px', marginRight: '10px' }}>Start Test</Button>
                    { <Button variant="dark" onClick={handleSubmit2} style={{ marginTop: '20px', marginLeft: '10px' }}>Sample Test</Button>}
                </div>

                {/* <Button variant="dark" onClick={handleSubmit} style={{ marginTop: '20px' }}>Start Test</Button>
                <Button variant="dark" onClick={handleSubmit2} style={{ marginTop: '40px' }}>Demo Test</Button> */}

            </div>
        </div>
        <footer >
      <p style={{color:'white'}}>&copy; {currentYear} Data Lake Solutions LLC. All rights reserved.</p>
      </footer>
        </div>
    );

}
export default InstructionsPage;
